import { Navigate, Outlet } from 'react-router-dom';
import useAuthentication from 'v3/hooks/useAuthentication';

import Loading from 'v3/shared/components/Loading/DefaultLoading';

interface GuardProps {
  redirectTo: string;
}

export const Guard = ({ redirectTo }: GuardProps) => {
  const { isLoggedin, fetching } = useAuthentication();
  if (fetching) return <Loading />;
  return isLoggedin ? <Outlet /> : <Navigate to={redirectTo} />;
};
